function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }),
  );
}

export const fetchJSON = async <T = JSON>(
  url: string,
  config = getDefaultRequestConfig(),
): Promise<T> => {
  const response = await get(url, config);

  return response.json();
};

export const get = async (url: string, config?: {}) => {
  const response = await window.fetch(url, config);

  if (!response.ok) {
    throw response;
  }

  return response;
};
